export const FEEDBACK_TOTAL_VARIANTS = 3

export const FEEDBACK_TYPE = {
  CORRECT: 'CORRECT',
  INCORRECT: 'INCORRECT',
  HINT: 'HINT'
}
